module.exports = __webpack_public_path__ + "ed6f86b7167572338a529df74a3965df.svg";